import { render, staticRenderFns } from "./InsuranceTableSingle.vue?vue&type=template&id=8b9b3c2c&"
import script from "./InsuranceTableSingle.vue?vue&type=script&lang=js&"
export * from "./InsuranceTableSingle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports